import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static targets = ['card', 'letter', 'input', 'background', 'padding'];
  static values = { answer: String };

  connect() {
    if (!this.hasAnswerValue || !this.answerValue) {
      this.initializeSelectedCards();
    }
  }

  initializeSelectedCards() {
    this.cardTargets.forEach((card) => {
      if (card.dataset.selected === 'true' && (!this.hasAnswerValue || !this.answerValue)) {
        const letter = card.querySelector('[data-trail-forms--controller-target="letter"]');
        const padding = card.querySelector('[data-trail-forms--controller-target="padding"]');
        const background = card.querySelector('[data-trail-forms--controller-target="background"]');

        if (background) {
          background.classList.remove('tw-bg-white', 'tw-border-coolGray-300');
          background.classList.add('tw-bg-primary-25', 'tw-border-primary-100');
        }

        if (padding) {
          padding.classList.remove('tw-bg-coolGray-400');
          padding.classList.add('tw-bg-primary-100');
        }

        if (letter) {
          letter.classList.remove('tw-border-coolGray-300');
          letter.classList.add('tw-border-primary-100');
          const letterText = letter.querySelector('p');
          if (letterText) {
            letterText.classList.remove('tw-text-coolGray-600');
            letterText.classList.add('tw-text-primary-500');
          }
        }
      }
    });
  }

  toggleBackground(event) {
    // Se answer estiver definida, não permitir mudança de seleção
    if (this.hasAnswerValue && this.answerValue) {
      return;
    }

    const selectedCard = event.currentTarget;

    this.cardTargets.forEach((card) => {
      const letter = card.querySelector('[data-trail-forms--controller-target="letter"]');
      const input = card.querySelector('[data-trail-forms--controller-target="input"]');
      const padding = card.querySelector('[data-trail-forms--controller-target="padding"]');
      const background = card.querySelector('[data-trail-forms--controller-target="background"]');

      if (card === selectedCard) {
        background.classList.remove('tw-bg-white');
        background.classList.add('tw-bg-primary-25');
        padding.classList.add('tw-bg-primary-100');
        padding.classList.remove('tw-bg-coolGray-400');
        background.classList.remove('tw-border-coolGray-300');
        background.classList.add('tw-border-primary-100');

        card.classList.remove('tw-bg-white', 'tw-border-coolGray-400');

        if (letter) {
          letter.classList.remove('tw-border-coolGray-300');
          letter.classList.add('tw-border-primary-100');
          const letterText = letter.querySelector('p');
          if (letterText) {
            letterText.classList.remove('tw-text-coolGray-600');
            letterText.classList.add('tw-text-primary-500');
          }
        }
        if (input) input.value = '1';

        // Atualizar o campo hidden com o ID da alternativa selecionada
        const selectedAlternativeField = document.getElementById('selected_alternative_id');
        if (selectedAlternativeField && card.dataset.alternativeId) {
          selectedAlternativeField.value = card.dataset.alternativeId;
        }

        // Disparar evento customizado para notificar que uma alternativa foi selecionada
        const event = new CustomEvent('alternativeSelected', {
          detail: { alternativeId: card.dataset.alternativeId },
        });
        document.dispatchEvent(event);
      } else {
        card.classList.remove('tw-bg-primary-25', 'tw-border-primary-100');
        card.classList.add('tw-bg-white', 'tw-border-coolGray-400');
        padding.classList.remove('tw-bg-primary-100');
        padding.classList.add('tw-bg-coolGray-400');
        background.classList.add('tw-bg-white');
        background.classList.remove('tw-bg-primary-25');
        background.classList.add('tw-border-coolGray-300');
        background.classList.remove('tw-border-primary-100');

        if (letter) {
          letter.classList.remove('tw-border-primary-100');
          letter.classList.add('tw-border-coolGray-300');
          const letterText = letter.querySelector('p');
          if (letterText) {
            letterText.classList.remove('tw-text-primary-500');
            letterText.classList.add('tw-text-coolGray-600');
          }
        }
        if (input) input.value = '0';
      }
    });
  }
}
